module.exports = __webpack_public_path__ + "static/media/wreath.d24e0da7.svg";